import LessonInfoTabs from './LessonInfoTabs';
// @ts-expect-error Could not find a declaration file for module
import StoredContentContainer from '../../containers/StoredContentContainer';
import { LessonContentWithInteractiveEducation } from './LessonContentWithInteractiveEducation';
import { SOFTWARE_DISCOVERY_TOOL_RECOMMENDATIONS, TRACK_NEXT_IN_PLAYLIST_URL_FRAGMENT, TRACK_PLAYLIST_COMPLETE_URL_FRAGMENT, TRACK_PLAYLIST_INCOMPLETE_URL_FRAGMENT, TRACK_RECOMMENDATIONS_URL_FRAGMENT } from '../../constants/Navigation';
import { NextPlaylistContentOverview, PlaylistComplete, PlaylistIncompleteItems } from '../../features/playlistContent';
import { LearningContentContainer } from '../../features/learningContent';
import { OptionalToolRecommendationSection } from '../../features/toolRecommendations';
import { LessonRecommendationsPage } from '../../features/lessons/components/LessonRecommendationsPage';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LessonPage = ({
  contentId,
  lesson,
  onAdvanceContent,
  onResourceClick,
  isRequesting = false
}) => {
  var _lesson$content;
  const lessonId = Number(lesson.id);
  const language = lesson.language || 'en';
  const numericContentId = contentId ? Number(contentId) : 0;
  const videoContent = (_lesson$content = lesson.content) === null || _lesson$content === void 0 ? void 0 : _lesson$content.find(c => c.id === numericContentId);
  const isVideoContent = videoContent && videoContent.contentType === 'VIDEO';
  const contentIdNumber = Number(contentId);
  switch (contentId) {
    case TRACK_RECOMMENDATIONS_URL_FRAGMENT:
      return /*#__PURE__*/_jsx(LessonRecommendationsPage, {
        id: lessonId,
        name: lesson.name
      });
    case TRACK_NEXT_IN_PLAYLIST_URL_FRAGMENT:
      return /*#__PURE__*/_jsx(NextPlaylistContentOverview, {
        lessonId: lessonId
      });
    case TRACK_PLAYLIST_INCOMPLETE_URL_FRAGMENT:
      return /*#__PURE__*/_jsx(PlaylistIncompleteItems, {});
    case TRACK_PLAYLIST_COMPLETE_URL_FRAGMENT:
      return /*#__PURE__*/_jsx(PlaylistComplete, {});
    case SOFTWARE_DISCOVERY_TOOL_RECOMMENDATIONS:
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(OptionalToolRecommendationSection, {
          contentName: lesson.name,
          lessonId: lessonId,
          useCases: lesson.useCases
        }), /*#__PURE__*/_jsx(LessonInfoTabs, {
          contentId: contentId,
          fullLesson: lesson,
          onResourceClick: onResourceClick
        })]
      });
    default:
      // Render video content with interactive education features
      if (isVideoContent && videoContent && contentId) {
        return /*#__PURE__*/_jsx(LessonContentWithInteractiveEducation, {
          lesson: lesson,
          lessonContentId: contentIdNumber,
          onAdvanceContent: onAdvanceContent,
          onResourceClick: onResourceClick,
          videoContent: videoContent
        });
      }

      // Render non-video content
      return /*#__PURE__*/_jsxs(LearningContentContainer, {
        contentId: numericContentId,
        language: language,
        lessonId: lessonId,
        children: [/*#__PURE__*/_jsx(StoredContentContainer, {
          contentId: contentId,
          isPubliclyVisible: lesson.visibility === 'PUBLIC',
          isRequesting: isRequesting,
          language: language,
          lessonId: lessonId,
          lessonName: lesson.name,
          onFinish: onAdvanceContent
        }), /*#__PURE__*/_jsx(LessonInfoTabs, {
          contentId: contentId,
          fullLesson: lesson,
          onResourceClick: onResourceClick
        })]
      });
  }
};
export default LessonPage;